import {Injectable} from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class SortService {

  constructor() {
  }

dynamicSort(property: string | string[]) {
  let sortOrder = 1;

  if (typeof property === 'string' && property.startsWith('-')) {
    sortOrder = -1;
    property = property.slice(1); // Use slice instead of substr
  }

  return (a: Record<string, any>, b: Record<string, any>) => {
    let result = 0;

    if (typeof property === 'string') {
      // Handle single property
      const propA = a[property]?.toString().toLowerCase() || '';
      const propB = b[property]?.toString().toLowerCase() || '';
      result = propA < propB ? -1 : propA > propB ? 1 : 0;
    } else if (Array.isArray(property)) {
      // Handle array of properties
      for (const prop of property) {
        const propA = a[prop]?.toString().toLowerCase() || '';
        const propB = b[prop]?.toString().toLowerCase() || '';
        result = propA < propB ? -1 : propA > propB ? 1 : 0;
        if (result !== 0) break; // Stop if a difference is found
      }
    }

    return result * sortOrder;
  };
}

  reduceArrayToMaxLength(array: any[], firebaseTimestampField: string, maxLength: number = 5) {
    // console.log(`Reducing array to max length from ${array.length} to ${maxLength}`);
    // Check if the array is empty
    if (array.length === 0) {
      // console.log('Array is empty, returning empty array');
      return [];
    }

    // If the array has only one element, return it directly
    if (array.length <= maxLength) {
      // console.log('Array length is less than or equal to max length, returning array');
      return array;
    }

    // Sort the array based on the timestamp field in descending order
    array.sort((a, b) => b[firebaseTimestampField].seconds - a[firebaseTimestampField].seconds);

    // Slice the array to a maximum length of maxLength
    const slicedArray = array.slice(0, maxLength);

    // console.log(`Array reduced to ${slicedArray.length} elements`);

    return slicedArray;
  }

}
